<div class="mfa-verify-page">
    <div class="mfa-verify-title">{{'aumico_mfa_verify_title' | i18next}}</div>
    <div class="mfa-verify-description">
        {{ (useBackupCode ? 'aumico_mfa_verify_backup_description' : 'aumico_mfa_verify_description') | i18next }}
    </div>

    <div class="mfa-verify-user-info" *ngIf="userEmail || organizationName">
        <div class="mfa-verify-user-info-row" *ngIf="userEmail">
            <span class="mfa-verify-user-info-value">{{ userEmail }}</span>
        </div>
        <div class="mfa-verify-user-info-row" *ngIf="organizationName">
            <span class="mfa-verify-user-info-value">{{ organizationName }}</span>
        </div>
    </div>

    <form [formGroup]="verifyForm" class="mfa-verify-form">
        <div class="form-group">
            <input
                hamInput
                formControlName="code"
                type="text"
                inputmode="numeric"
                [maxlength]="useBackupCode ? 20 : 6"
                [placeholder]="(useBackupCode ? 'aumico_mfa_verify_backup_code_placeholder' : 'aumico_mfa_verify_code_placeholder') | i18next"
            />
        </div>
    </form>

    <div *ngIf="errorMessage" class="mfa-error">{{ errorMessage | i18next }}</div>

    <div class="mfa-actions">
        <ham-button [disabled]="verifyForm.invalid || isLoading" (buttonClick)="onVerify()">
            {{'aumico_mfa_verify_submit_button' | i18next}}
        </ham-button>
    </div>

    <div class="mfa-toggle-backup">
        <button class="mfa-backup-toggle-btn" type="button" (click)="toggleBackupCode()">
            {{ (useBackupCode ? 'aumico_mfa_verify_use_totp_code' : 'aumico_mfa_verify_use_backup_code') | i18next }}
        </button>
    </div>
</div>
